import { render, staticRenderFns } from "./RsaScalaBarthelViewComponent.vue?vue&type=template&id=1af6a19d"
import script from "./RsaScalaBarthelViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaBarthelViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports